exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tag-9bfb0{padding:1px 8px;font-size:10px;border-radius:12px}", ""]);

// Exports
exports.locals = {
	"tag": "tag-9bfb0"
};